import * as React from 'react';
import { RadioButtonGroup } from '@gandi/ui/deprecated';
import FormGroup from '../decorators/FormGroup';
import FormField from '../wrappers/FormField';
import decorateControl from '../wrappers/decorateControl';
import { jsx as _jsx } from "react/jsx-runtime";
const component = decorateControl(RadioButtonGroup, FormGroup);
// $FlowFixMe[missing-local-annot]
const normalizeCheckboxesValues = props => (value, previousValue) => {
  if (props.type && props.type === 'checkbox') {
    // We receive two times a value for each onChange call.
    // The first one we receive a boolean, which we ignore
    // (as we can't know for which checkbox this boolean is for),
    // the second time is from the manual call to redux-form's props.onChange
    // with the correct array value (done in RadioButtonGroup.js itself).
    if (Array.isArray(previousValue) && !Array.isArray(value)) {
      return previousValue;
    }
  }
  return value;
};

/**
 * @deprecated cf. controls
 */
const RadioButtonGroupField = props =>
/*#__PURE__*/
// $FlowFixMe[cannot-spread-inexact]
_jsx(FormField, {
  normalize: normalizeCheckboxesValues(props),
  ...props,
  component: component
});
export default RadioButtonGroupField;